import React from 'react';
import { Box, Container, Typography, Button } from '@mui/material';
import LoginIcon from '@mui/icons-material/Login';
import AssignmentIcon from '@mui/icons-material/Assignment';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import COLORS from '../../../../theme/Colors';
import FONTS_FAMILY from '../../../../theme/FontsFamily';
import Fade from 'react-reveal/Fade';
import { useHistory } from 'react-router-dom';

const steps = [
  {
    stepNum: 'PASO 01',
    icon: <LoginIcon sx={{ fontSize: 30, color: COLORS.tertiary }} />,
    title: 'Inicia sesión',
    description: 'Entra con tu cuenta o regístrate en el portal si aún no tienes un usuario.'
  },
  {
    stepNum: 'PASO 02',
    icon: <AssignmentIcon sx={{ fontSize: 30, color: COLORS.tertiary }} />,
    title: 'Completa la solicitud',
    description: 'Llena el formulario en línea y adjunta la documentación según el tipo de trámite.'
  },
  {
    stepNum: 'PASO 03',
    icon: <CreditCardIcon sx={{ fontSize: 30, color: COLORS.tertiary }} />,
    title: 'Realiza el pago',
    description: 'Paga en línea el servicio correspondiente, cuando aplique, y recibe tu confirmación.'
  }
];

const StepByStep = ({ onActionClick }) => {
  const history = useHistory();

  return (
    <Box sx={{ py: 9, bgcolor: 'white', textAlign: 'center' }}>
      <Container maxWidth="lg">
        <Fade bottom>
          <Box sx={{ mb: 6, textAlign: 'center', maxWidth: 700, mx: 'auto' }}>
            <span className="uctt-eyebrow no-dash" style={{ justifyContent: 'center' }}>Cómo funciona</span>
            <Typography
              variant="h3"
              sx={{ color: COLORS.secondary, mt: 1.5, mb: 1.5, fontWeight: 800, fontSize: { xs: '1.8rem', md: '2.4rem' }, fontFamily: FONTS_FAMILY.bold.title }}
            >
              De la solicitud a la licencia, en tres pasos
            </Typography>
            <Typography
              variant="body1"
              sx={{ color: '#57697F', fontSize: '1.05rem', fontFamily: FONTS_FAMILY.regular.body }}
            >
              Un flujo guiado de principio a fin, para que sepas siempre en qué punto está tu expediente.
            </Typography>
          </Box>
        </Fade>

        <Fade bottom delay={200}>
          <div className="uctt-rail">
            {steps.map((step, index) => (
              <div className="uctt-rstep" key={index}>
                <span className="n">{step.stepNum}</span>
                <div className="i">{step.icon}</div>
                <h3>{step.title}</h3>
                <p>{step.description}</p>
                {index < 2 && (
                  <div className="arrow">
                    <ArrowForwardIosIcon sx={{ fontSize: 12 }} />
                  </div>
                )}
              </div>
            ))}
          </div>
        </Fade>

        <Fade bottom delay={400}>
          <Box sx={{ mt: 5, display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
            <Button
              variant="contained"
              sx={{
                bgcolor: COLORS.secondary,
                color: 'white',
                px: 4,
                py: 1.4,
                borderRadius: 3,
                fontWeight: 700,
                fontSize: '0.95rem',
                textTransform: 'none',
                boxShadow: '0 4px 14px rgba(32,42,93,0.25)',
                '&:hover': { bgcolor: '#161d42' }
              }}
              onClick={onActionClick}
            >
              Iniciar una solicitud
            </Button>
            <Button
              variant="outlined"
              sx={{
                borderColor: '#CFDCE0',
                color: COLORS.secondary,
                px: 4,
                py: 1.4,
                borderRadius: 3,
                fontWeight: 700,
                fontSize: '0.95rem',
                textTransform: 'none',
                '&:hover': { borderColor: COLORS.tertiary, color: COLORS.tertiary, bgcolor: 'transparent' }
              }}
              onClick={() => history.push('/todos-los-tramites')}
            >
              Ver todos los trámites
            </Button>
          </Box>
        </Fade>
      </Container>
    </Box>
  );
};

export default StepByStep;
